import controller from './cancel-subscription-dialog.controller';

export default {
  controller,
  template: require('./cancel-subscription-dialog.html')
};



// WEBPACK FOOTER //
// src/app/buy/cancel-subscription-dialog/cancel-subscription-dialog.component.ts